export const categories = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 856, color: 'bg-primary-500' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 723, color: 'bg-accent-500' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 641, color: 'bg-secondary-500' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', count: 389, color: 'bg-primary-500' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 512, color: 'bg-accent-500' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 467, color: 'bg-secondary-500' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line', count: 345, color: 'bg-primary-500' },
];

export const categoryComics = [
  {
    id: 'comic-1',
    title: '剑与魔法',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20adventure%20cover%20art%20featuring%20a%20warrior%20with%20sword%20and%20magical%20energy%2C%20dramatic%20lighting%2C%20epic%20composition%2C%20detailed%20illustration%2C%20warm%20golden%20and%20dark%20tones%2C%20professional%20comic%20cover%20design&width=400&height=560&seq=cat-comic-01&orientation=portrait',
    rating: 9.6,
    reads: '1.2亿',
    status: '连载中',
    genres: ['奇幻', '动作'],
    updateDay: '每周一、四更新',
  },
  {
    id: 'comic-2',
    title: '甜蜜陷阱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20featuring%20a%20beautiful%20couple%20in%20soft%20embrace%2C%20pastel%20pink%20and%20warm%20tones%2C%20romantic%20atmosphere%2C%20delicate%20linework%2C%20professional%20webtoon%20cover%20style&width=400&height=560&seq=cat-comic-02&orientation=portrait',
    rating: 9.3,
    reads: '8900万',
    status: '连载中',
    genres: ['恋爱', '日常'],
    updateDay: '每周二、五更新',
  },
  {
    id: 'comic-4',
    title: '重生之帝',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20reincarnation%20manhwa%20cover%20art%2C%20ancient%20oriental%20palace%20background%2C%20powerful%20emperor%20figure%2C%20golden%20crimson%20tones%2C%20grand%20atmosphere%2C%20detailed%20costume%2C%20professional%20webtoon%20cover&width=400&height=560&seq=cat-comic-04&orientation=portrait',
    rating: 9.7,
    reads: '2.5亿',
    status: '连载中',
    genres: ['奇幻', '动作'],
    updateDay: '每周一、四更新',
  },
  {
    id: 'comic-5',
    title: '办公室罗曼史',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%20art%2C%20stylish%20business%20couple%20in%20modern%20office%2C%20soft%20warm%20lighting%2C%20elegant%20fashion%2C%20romantic%20atmosphere%2C%20clean%20professional%20webtoon%20style&width=400&height=560&seq=cat-comic-05&orientation=portrait',
    rating: 9.2,
    reads: '1.1亿',
    status: '连载中',
    genres: ['恋爱', '日常'],
    updateDay: '每周二、五更新',
  },
  {
    id: 'comic-6',
    title: '末日生存指南',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20post-apocalyptic%20survival%20manhwa%20cover%20art%2C%20destroyed%20cityscape%20background%2C%20survivor%20with%20weapon%2C%20dramatic%20orange%20sky%2C%20intense%20atmosphere%2C%20detailed%20ruins%2C%20professional%20webtoon%20cover&width=400&height=560&seq=cat-comic-06&orientation=portrait',
    rating: 9.4,
    reads: '9800万',
    status: '已完结',
    genres: ['动作', '悬疑'],
    updateDay: '已完结',
  },
  {
    id: 'comic-7',
    title: '魔法学院',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20magic%20academy%20manhwa%20cover%20art%2C%20students%20in%20magical%20school%20uniforms%2C%20floating%20spells%20books%2C%20gothic%20architecture%2C%20mystical%20blue%20gold%20tones%2C%20professional%20webtoon%20cover&width=400&height=560&seq=cat-comic-07&orientation=portrait',
    rating: 9.1,
    reads: '7500万',
    status: '连载中',
    genres: ['奇幻', '日常'],
    updateDay: '每周三、六更新',
  },
  {
    id: 'comic-8',
    title: '江湖风云录',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20murim%20manhwa%20cover%20art%2C%20warrior%20in%20traditional%20hanbok%20with%20sword%2C%20mountain%20landscape%2C%20ink%20wash%20painting%20style%2C%20dramatic%20elegant%20traditional%20aesthetic&width=400&height=560&seq=cat-comic-08&orientation=portrait',
    rating: 9.5,
    reads: '1.6亿',
    status: '连载中',
    genres: ['动作', '剧情'],
    updateDay: '每周一、四更新',
  },
  {
    id: 'comic-9',
    title: '猫咪咖啡厅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%20art%2C%20cozy%20cat%20cafe%20interior%2C%20cute%20cats%20warm%20atmosphere%2C%20soft%20pastel%20colors%2C%20healing%20vibe%2C%20gentle%20lighting%2C%20professional%20webtoon%20cover&width=400&height=560&seq=cat-comic-09&orientation=portrait',
    rating: 9.0,
    reads: '5200万',
    status: '已完结',
    genres: ['日常', '搞笑'],
    updateDay: '已完结',
  },
  {
    id: 'comic-10',
    title: '星之旅人',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20fantasy%20manhwa%20cover%20art%2C%20space%20traveler%20with%20stars%20and%20galaxy%20background%2C%20dreamy%20atmosphere%2C%20soft%20blue%20purple%20pink%20tones%2C%20beautiful%20composition%2C%20professional%20webtoon%20cover%20design&width=400&height=560&seq=cat-comic-10&orientation=portrait',
    rating: 9.3,
    reads: '6300万',
    status: '连载中',
    genres: ['奇幻', '剧情'],
    updateDay: '每周五更新',
  },
];